export default __webpack_public_path__ + "8653f9f23ca93435840c75742d4bc118.png";